
import { FRONTEND_ROUTES } from "../Routes/frontend_routes";

export const SUCCESS_FLOWS = {
    PURE_PATIENT: {
        title: "welcome_patient_title",
        icon: "heart-pulse-fill",
        features: ["feat_history", "feat_prescriptions", "feat_appointments"],
        primaryAction: "go_to_dashboard",
        redirectTo: FRONTEND_ROUTES.dashboard,
    },
    PURE_PROFESSIONAL: {
        title: "pro_pending_title",
        icon: "shield-lock-fill",
        isPending: true,
        statusKey: "status_under_review",
        estimatedTime: "24-48h",
        features: ["feat_license_check", "feat_identity_verify", "feat_background_check"],
        primaryAction: "go_to_landing",
        redirectTo: FRONTEND_ROUTES.test,
    },
    PATIENT_TO_PRO: {
        title: "pro_pending_title",
        icon: "person-badge-fill",
        isPending: true,
        statusKey: "status_under_review",
        estimatedTime: "24-48h",
        features: ["feat_license_check", "feat_identity_verify"],
        primaryAction: "stay_as_patient",
        redirectTo: FRONTEND_ROUTES.test,
    },
    PRO_TO_PATIENT: {
        title: "upgrade_patient_title",
        icon: "person-badge-fill",
        features: ["feat_self_history", "feat_clinical_view", "feat_dual_role"],
        primaryAction: "view_my_health",
        redirectTo: FRONTEND_ROUTES.test,
    },
};